import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import PhysicalDesign from './courses/PhysicalDesign';
import LongTerm from './courses/LongTerm';
import ShortTerm from './courses/ShortTerm';
import DftCourse from './courses/DftCourse';

const AppRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/courses/physical-design" element={<PhysicalDesign />} />
            <Route path="/courses/physical-design/long-term" element={<LongTerm />} />
            <Route path="/courses/physical-design/short-term" element={<ShortTerm />} />
            <Route path="/courses/dft" element={<DftCourse />} />
        </Routes>
    );
};

export default AppRouter;